module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';

 
disabled = "";
 
if (viewable){
  disabled = "disabled";
}
 

__p+='\r\n    <section class="content-headerFixed">\r\n\r\n\r\n        <input type="hidden" value="'+
((__t=( id_good ))==null?'':_.escape(__t))+
'_3999_222x" id="id_good_id_x" name="id_good_id_x">\r\n\r\n\r\n        <div class="form-group col-md-8 col-xs-8 no-padding">\r\n            <span class="btn btn-sm btn-flat btn-info" id="tabView">\r\n            <i class="fa fa-list-alt"></i> <span class="hideOnMobile"> '+
((__t=( lang.VIEW_TABS))==null?'':_.escape(__t))+
'</span>\r\n            </span>\r\n            <span class="btn btn-sm btn-flat btn-info" id="listView">\r\n            <i class="fa fa-list"></i> <span class="hideOnMobile"> '+
((__t=( lang.VIEW_LIST))==null?'':_.escape(__t))+
'</span>\r\n            </span>\r\n            ';
    
            ////SOLO PARA EL USUARIO Castellote Campamà  -- Sebastià Hierro.
            if(iduser_get == 102 || iduser_get == 47 ){ 
__p+='\r\n                <span class="btn btn-sm btn-flat btn-primary" id="clone">\r\n            <i class="fa fa-copy"></i> <span class="hideOnMobile"> '+
((__t=( lang.CLONE))==null?'':_.escape(__t))+
'</span>\r\n                </span>\r\n                ';
 
            }else{
                 if(rooll  < 3){ 
__p+='\r\n                    <span class="btn btn-sm btn-flat btn-primary" id="clone">\r\n            <i class="fa fa-copy"></i> <span class="hideOnMobile"> '+
((__t=( lang.CLONE))==null?'':_.escape(__t))+
'</span>\r\n                    </span>\r\n                    ';
  }  
            }
            
__p+='\r\n\r\n                        <span class="btn btn-sm btn-flat btn-warning" id="pdf">\r\n            <i class="fa fa-file-pdf-o"></i> <span class="hideOnMobile"> PDF </span>\r\n                        </span>\r\n                        <span class="dropdown">\r\n            <span class="btn btn-sm btn-flat bg-purple" id="history">\r\n                <span class="glyphicon glyphicon-repeat"></span> <span class="hideOnMobile">'+
((__t=( lang.HISTORIC))==null?'':_.escape(__t))+
'</span> <span class="caret"></span>\r\n                        </span>\r\n                        <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenu1" id="historyList">\r\n                            <li>\r\n                                <a>\r\n                                    '+
((__t=( lang.NORECORDS ))==null?'':_.escape(__t))+
'\r\n                                </a>\r\n                            </li>\r\n                        </ul>\r\n                        </span>\r\n                        <!-- <span class="btn btn-sm btn-flat bg-olive" id="amortizaciones">\r\n            <i class="fa fa-calculator"></i> <span class="hideOnMobile">'+
((__t=( lang.AMORTIZACION))==null?'':_.escape(__t))+
'</span>\r\n        </span> -->\r\n        </div>\r\n        ';
 
        if(isEditableBien >= 1){
            
__p+='\r\n            <div class="text-right col-md-4 col-xs-4 no-padding" id="sendForm">\r\n                <span class="btn btn-sm btn-flat btn-success" id="send">'+
((__t=( lang.SAVE ))==null?'':_.escape(__t))+
'</span>\r\n            </div>\r\n            ';
  
         }
          
__p+='\r\n\r\n                <div class="clear"></div>\r\n    </section>\r\n\r\n    <section class="content">\r\n        <div class="row content-marginFixed" id="goodContents">\r\n\r\n            <div class="col-md-12">\r\n                <p>&nbsp;</p>\r\n\r\n                <ul class="nav nav-tabs" id="generalTabs" role="tablist">\r\n                    <li role="presentation" class="active">\r\n                        <a id="home-tab">\r\n                            '+
((__t=( lang.GENERAL ))==null?'':_.escape(__t))+
'\r\n                        </a>\r\n                    </li>\r\n                </ul>\r\n                <form id="goods">\r\n                    <div class="tab-pane active">\r\n\r\n                        <input type="hidden" value="'+
((__t=( attributes.epigraph ))==null?'':_.escape(__t))+
'" id="lab_epigra_tte" name="lab_epigra_tte">\r\n                        <input type="hidden" value="'+
((__t=( attributes.itemId ))==null?'':_.escape(__t))+
'" id="good_id_itemID" name="good_id_itemID">\r\n                        <input type="hidden" value="'+
((__t=( attributes.itemId ))==null?'':_.escape(__t))+
'" id="vvv" name="vvv">\r\n\r\n\r\n                        <!-- Código -->\r\n                        <div class="col-md-1 col-sm-3 col-xs-6 titleField">\r\n                            <label for="itemId">'+
((__t=( lang.CODIGO ))==null?'':_.escape(__t))+
':</label>\r\n                        </div>\r\n                        <div class="col-md-1 col-sm-3 col-xs-6 inputField form-group">\r\n                            <input type="number" value="'+
((__t=( attributes.itemId ))==null?'':_.escape(__t))+
'" id="itemId" class="form-control" disabled/>\r\n                        </div>\r\n\r\n                        <!-- Ref. Interna -->\r\n                        <div class="col-md-2 col-sm-3 col-xs-6 titleField">\r\n                            <label for="ref">'+
((__t=( lang.REF_INTERNA ))==null?'':_.escape(__t))+
':</label>\r\n                        </div>\r\n                        <div class="col-md-1 col-sm-3 col-xs-6 inputField form-group">\r\n                            <input type="text" value="'+
((__t=( attributes.ref ))==null?'':_.escape(__t))+
'" id="ref" class="form-control " '+
((__t=( disabled ))==null?'':_.escape(__t))+
'/>\r\n                        </div>\r\n\r\n                        <!--Fecha Alta -->\r\n                        <div class="col-md-2 col-sm-3 col-xs-6 titleField">\r\n                            <label class="control-label" for="fechaAlta">'+
((__t=( lang.FECHA_ALTA ))==null?'':_.escape(__t))+
':</label>\r\n                        </div>\r\n                        <div class="col-md-2 col-sm-3 col-xs-6 inputField form-group">\r\n                            <div id=\'dtpickerAlta\' class="input-group">\r\n                                <input type=\'text\' id="fechaAlta" name="start" class="form-control date" value="'+
((__t=( attributes.fechaAlta ))==null?'':_.escape(__t))+
'" '+
((__t=( disabled ))==null?'':_.escape(__t))+
'/>\r\n                                <span class="input-group-addon">\r\n                                    <span class="glyphicon glyphicon-calendar"></span>\r\n                                </span>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <!-- Estado -->\r\n                        <div class="col-md-1 col-sm-3 col-xs-6 titleField">\r\n                            <label for="ref">'+
((__t=( lang.URBANISTICOS_ESTADO ))==null?'':_.escape(__t))+
':</label>\r\n                        </div>\r\n                        <div class="col-md-2 col-sm-3 col-xs-6 inputField form-group">\r\n                            <select id="descriptivos_estado" '+
((__t=( disabled ))==null?'':_.escape(__t))+
'  class="form-control">\r\n                                <option value="">[ -- ]</option>\r\n                                ';

                                for (var i = 1; i <= 5; i++) {
                                    var selected = "";
                                    if (attributes.descriptivos_estado === 'ESTADO_' + i)
                                        selected = "selected";
                                    print('<option value="ESTADO_' + i + '" ' + selected + '>' + lang['ESTADO_' + i] + '</option>');
                                }
                                
__p+='\r\n                            </select>\r\n                        </div>\r\n\r\n                        <div class="clear"></div>\r\n\r\n                        <!-- Entidad -->\r\n                        <div class="col-md-2 col-sm-3 col-xs-6 titleField">\r\n                            <label for="entity">'+
((__t=( lang.ENTIDAD ))==null?'':_.escape(__t))+
':</label>\r\n                        </div>\r\n                        <div class="col-md-4 col-sm-3 col-xs-6 inputField form-group">\r\n                            <select id="entity" class="form-control required" '+
((__t=( disabled ))==null?'':_.escape(__t))+
'>\r\n                                ';
 


                                for (i in parameters.entidades) {
                                    var param = parameters.entidades[i];
                                    var selected = "";
                                    if (attributes.entity === param.word)
                                        selected = "selected";
                                    print('<option value="' + param.word + '" ' + selected + '>' + param.translation + '</option>');
                                }
                                
__p+='\r\n                            </select>\r\n                        </div>\r\n\r\n                        <!-- Área funcional -->\r\n                        <div class="col-md-2 col-sm-3 col-xs-6 titleField">\r\n                            <label for="areaFuncional">'+
((__t=( lang.A_FUNCIONAL ))==null?'':_.escape(__t))+
':</label>\r\n                        </div>\r\n                        <div class="col-md-4 col-sm-3 col-xs-6 inputField form-group">\r\n                            <select id="areaFuncional" class="form-control" '+
((__t=( disabled ))==null?'':_.escape(__t))+
'>\r\n                                ';

                                for (i in parameters.areas) {
                                    var param = parameters.areas[i];
                                    var selected = "";
                                    if (attributes.areaFuncional === param.word)
                                        selected = "selected";
                                    print('<option value="' + param.word + '" ' + selected + '>' + param.translation + '</option>');
                                }
                                
__p+='\r\n                            </select>\r\n                        </div>\r\n\r\n                        <div class="clear"></div>\r\n\r\n                        <!-- Epígrafe -->\r\n                        <div class="col-md-2 col-sm-3 col-xs-6 titleField">\r\n                            <label for="epigraph">'+
((__t=( lang.EPIGRAFE ))==null?'':_.escape(__t))+
':</label>\r\n                        </div>\r\n                        <div class="col-md-4 col-sm-3 col-xs-6 inputField form-group">\r\n                            ';
 
                            
                              
                            var disabledEpigraph = ""; 
                            
                            if (attributes.id){
                                disabledEpigraph = "";
                                if(rooll == 0){ 
                                   disabledEpigraph = ""; 
                                }else{
                                     disabledEpigraph = "disabled";
                                }   
                            }
  
                            
                                
__p+='\r\n                                <select id="epigraph" class="form-control" '+
((__t=( disabled ))==null?'':_.escape(__t))+
'>\r\n                                ';
  
                                var epigraSelected = null;
                                   
                                for (i in parameters.epigraphs) {
                                    var param = parameters.epigraphs[i];
                                    var selected = "";
                                    if (attributes.epigraph === param.word){
                                         epigraSelected  =  param.translation;
                                        selected = "selected";
                                    }
                                    print('<option value="' + param.word + '" ' + selected + '>' + param.translation + '</option>');
                                }
                                
__p+='\r\n                            </select>\r\n                        </div>\r\n\r\n                        <!-- Tipo gestión -->\r\n                        <div class="col-md-2 col-sm-3 col-xs-6 titleField">\r\n                            <label for="tipoGestion">'+
((__t=( lang.TIPO_GESTION ))==null?'':_.escape(__t))+
':</label>\r\n                        </div>\r\n                        <div class="col-md-4 col-sm-3 col-xs-6 inputField form-group">\r\n                            <select id="tipoGestion" class="form-control" '+
((__t=( disabled ))==null?'':_.escape(__t))+
'>\r\n                                ';

                                for (i in parameters.gestion) {
                                    var param = parameters.gestion[i];
                                    var selected = "";
                                    if (attributes.tipoGestion === param.word)
                                        selected = "selected";
                                    print('<option value="' + param.word + '" ' + selected + '>' + param.translation + '</option>');
                                }
                                
__p+='\r\n                            </select>\r\n                        </div>\r\n\r\n                        <div class="clear"></div>\r\n\r\n                        <!-- Baja -->\r\n                        <div class="col-md-2 col-sm-3 col-xs-6 titleField">\r\n                            <label for="baja_s">'+
((__t=( lang.BAJA ))==null?'':_.escape(__t))+
':</label>\r\n                        </div>\r\n                        <div class="col-md-1 col-sm-3 col-xs-6 inputField form-group">\r\n                            <div>\r\n                                ';

                            var checked = "";
                           if(attributes.baja == 1){ 
                                checked = "checked";
                            }
        
                            
__p+='\r\n                                    <input type="checkbox" id="baja" '+
((__t=( checked ))==null?'':_.escape(__t))+
'\r\n                                    '+
((__t=( disabled ))==null?'':_.escape(__t))+
'/>\r\n                                        ';

                            var disabledBaja = "";
                            //Disable baja parameters
                            if (attributes.baja === "0")
                                disabledBaja = "disabled";
                            
__p+='\r\n                            </div>\r\n                        </div>\r\n\r\n                        <!-- Fecha -->\r\n                        <div class="col-md-2 col-sm-3 col-xs-6 titleField">\r\n                            <label id="fec_baja_label" class="control-label" for="fechaBaja">'+
((__t=( lang.FECHA_BAJA ))==null?'':_.escape(__t))+
':</label>\r\n                        </div>\r\n                        <div class="col-md-3  col-sm-3 col-xs-6 inputField form-group">\r\n                            <div id=\'dtpickerBaja\' class="input-group">\r\n                                <input type=\'text\' id="fechaBaja" name="start" value="'+
((__t=(attributes.fechaBaja ))==null?'':_.escape(__t))+
'" class="form-control date" '+
((__t=( disabledBaja ))==null?'':_.escape(__t))+
'/>\r\n                                <span class="input-group-addon">\r\n                                <span class="glyphicon glyphicon-calendar"></span>\r\n                                </span>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div class="clear"></div>\r\n\r\n                        <!-- Motivo -->\r\n                        <div class="col-md-2 col-sm-3 col-xs-6 titleField">\r\n                            <label for="motivoBaja">'+
((__t=( lang.MOTIVO_BAJA ))==null?'':_.escape(__t))+
':</label>\r\n                        </div>\r\n                        <div class="col-md-10 col-sm-9 col-xs-6 inputField form-group">\r\n                            <textarea id="motivoBaja" rows="4" class="form-control" '+
((__t=( disabledBaja ))==null?'':_.escape(__t))+
'>'+
((__t=( attributes.motivoBaja ))==null?'':_.escape(__t))+
'</textarea>\r\n                        </div>\r\n\r\n                        <div class="clear"></div>\r\n\r\n                        ';


                         
                        /*
                        var epigraSelected = null;
                        for (i in parameters.epigraphs) {
                            var param = parameters.epigraphs[i];
                           
                            if (attributes.epigraph === param.word){ 
                                epigraSelected  =  param.translation;
                            }
                        } 
                        */
                             
                        var isConstruc = null;
                        /*
                        ////ESTO ES LO QUE HE QUITADO 
                        if(epigraSelected){
                            isConstruc = epigraSelected.match(/construccions/g);
                        }
                        */
                        
                      
                        var disabledTerre = "disabled";
                        if(rooll == 0){
                            disabledTerre = '';
                        }
 
                        if(isConstruc){
                        
__p+='\r\n                            <!-- ID TERRENO ASOCIADO -->\r\n                            <div class="col-md-2 col-sm-3 col-xs-6 titleField">\r\n                                <label for="id_terrenasoci">'+
((__t=( lang.TERRENO_ASOCIADO_ID ))==null?'':_.escape(__t))+
':</label>\r\n                            </div>\r\n                            <div class="col-md-10 col-sm-9 col-xs-6 inputField form-group">\r\n                                <input type=\'text\' id="id_terrenasoci" name="id_terrenasoci" class="form-control date" value="'+
((__t=( attributes.name_terrenoAsociado ))==null?'':_.escape(__t))+
'" '+
((__t=( disabledTerre ))==null?'':_.escape(__t))+
' />\r\n                            </div>\r\n                            ';
 
                        } 
                        
__p+='\r\n\r\n                                <!-- enCurso -->\r\n                                <div class="col-md-2 col-sm-3 col-xs-6 titleField">\r\n                                    <label for="baja_s">'+
((__t=( lang.ENCURSO ))==null?'':_.escape(__t))+
':</label>\r\n                                </div>\r\n                                <div class="col-md-1 col-sm-3 col-xs-6 inputField form-group">\r\n                                    <div>\r\n                                        ';

                                    var checked = "";
                                    var disabledCurso = "";
                                    //Se mira si está marcada
                                    if(attributes.enCurso == 1){ 
                                        checked = "checked";
                                    }
                                    else{
                                        //Si no está marcada
                                        //Se mira si se hace de nuevo o no
                                        if (!nuevo)//Si no es nuevo se deshabilita el campo
                                            disabledCurso = "disabled";
                                    }
                
                                
__p+='\r\n                                            <input type="checkbox" id="enCurso" '+
((__t=( checked ))==null?'':_.escape(__t))+
'\r\n                                            '+
((__t=( disabledCurso ))==null?'':_.escape(__t))+
'/>\r\n\r\n                                    </div>\r\n                                </div>\r\n                                <!-- Fecha encurso Inicial -->\r\n                                <!--      <div class="col-md-2 col-sm-3 col-xs-6 titleField">\r\n                            <label id="fec_cursoIni_label" class="control-label" for="fechaCursoIni">'+
((__t=( lang.ENCURSOINI ))==null?'':_.escape(__t))+
':</label>\r\n                        </div>\r\n                        <div class="col-md-2  col-sm-3 col-xs-6 inputField form-group">\r\n                            <div id=\'dtpickerCursoIni\' class="input-group">\r\n                                <input type=\'text\' id="fechaCursoIni" name="start" value="'+
((__t=(attributes.fechaCursoIni ))==null?'':_.escape(__t))+
'" class="form-control date" '+
((__t=( disabled ))==null?'':_.escape(__t))+
'/>\r\n                                <span class="input-group-addon">\r\n                                <span class="glyphicon glyphicon-calendar"></span>\r\n                                </span>\r\n                            </div>\r\n                        </div>-->\r\n                                <!-- Fecha encurso final-->\r\n                                <div class="col-md-2 col-sm-3 col-xs-6 titleField">\r\n                                    <label id="fec_cursoFin_label" class="control-label" for="fechaCursoFin">'+
((__t=( lang.ENCURSOFIN ))==null?'':_.escape(__t))+
':</label>\r\n                                </div>\r\n                                <div class="col-md-2  col-sm-3 col-xs-6 inputField form-group">\r\n                                    <div id=\'dtpickerCursoFin\' class="input-group">\r\n                                        <input type=\'text\' id="fechaCursoFin" name="start" value="'+
((__t=(attributes.fechaCursoFin ))==null?'':_.escape(__t))+
'" class="form-control date" disabled/>\r\n                                        <!-- <span class="input-group-addon">\r\n                                <span class="glyphicon glyphicon-calendar"></span>\r\n                                </span>-->\r\n                                    </div>\r\n                                </div>\r\n                    </div>\r\n                </form>\r\n\r\n                <!--Tab button lines-->\r\n                <ul class="nav nav-tabs" id="Tabs" role="tablist">\r\n\r\n                    ';
 
                   
                    for (i in parameters.listSections) {
                        var sectionPara = parameters.listSections[i];

                        var activeClas = '';
                        if(sectionPara.keyWord == 'DESCRIPTIVOS'){
                           activeClas = 'active' ;
                        }

                        print('<li role="presentation" class="'+activeClas+'"> <a href="#'+sectionPara.idHtml+'" id="'+sectionPara.idHtml+'-tab" role="tab" data-toggle="tab" aria-controls="'+sectionPara.idHtml+'" aria-expanded="true">'+lang[sectionPara.keyWord]+'  </a></li>'); 
                         
                    } 
                    
                    
__p+='\r\n\r\n                </ul>\r\n                <!--Tabs-->\r\n\r\n                <div class="tab-content">\r\n\r\n                    ';
 
                     
                    for (i in parameters.listSections) {

                        var sectionPara = parameters.listSections[i];

                       var activeClasss = '';
                        if(sectionPara.keyWord == 'DESCRIPTIVOS'){
                           activeClasss = 'active' ;
                        }
 
                      print('<div class="listHeader" id="'+sectionPara.idHtml+'-list"> '+lang[sectionPara.keyWord]+' </div> <div class="tab-pane  '+activeClasss+'" role="tabpanel" id="'+ sectionPara.idHtml+'" aria-labelledby="'+ sectionPara.idHtml+'-tab"></div>'); 
                         
                    }
                
__p+='\r\n\r\n                </div>\r\n\r\n\r\n                <div class="clear"></div>\r\n\r\n            </div>\r\n    </section>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/goodsDetail/goodsDetailView.ejs
// module id = 414
// module chunks = 0